import * as basicScroll from 'basicscroll'

export default {
  inserted(el, { modifiers, expression }) {
    if (typeof window !== 'undefined') {
      el.__scroll = basicScroll.create({
        elem: el,
        from: modifiers.window ? 0 : 'middle-top',
        to: modifiers.window ? window.outerHeight : 'middle-bottom',
        direct: true,
        props: {
          [`--${expression || 'scroll-progress'}`]: {
            from: '0',
            to: '1',
          },
        },
      })
      el.__scroll.start()
    }
  },
}
